import { ComponentType, useState } from 'react';
import { TextField, TextFieldProps, Grid, Alert, AlertTitle, Chip } from '@mui/material';
import dayjs from 'dayjs';
import { styled } from '@mui/material/styles';

import { Heading, NButton } from '@ui-kit';
import { getCsvData } from '@utils/api';

const QueryField: ComponentType<TextFieldProps> = styled(TextField)`
	width: 50%;
`;

export const ManualQuery: React.FC = () => {
	const startOfMonth = dayjs().startOf('month').format('YYYY-MM-DD');
	const endOfMonth = dayjs().endOf('month').format('YYYY-MM-DD');
	const [value, setValue] = useState(`project = "AM" AND worklogDate >= ${startOfMonth} AND worklogDate <= ${endOfMonth}`);

	const handleDownloadClick = () => {
		getCsvData(value);
	};

	return (
		<Grid container direction="column" alignItems="center" justifyContent="center" marginTop="100px">
			<Heading>Manual Query</Heading>
			<QueryField id="outlined-multiline-flexible" label="Query" multiline maxRows={4} value={value} onChange={(event) => setValue(event.target.value)} />
			<Alert severity="info" sx={{ marginTop: '30px', width: '50%' }}>
				<AlertTitle>What is the duration after a change (i.e., write) where search consistency is assured?</AlertTitle>
				The eventual consistency delay is dependent on various factors. 99% of modifications are typically visible within seconds. However, non organic updates or
				operations that impact numerous issues, such as lexorank rebalancing or bulk editing, may require more time to complete.
				<br />
				<br />
				<Chip label="DEPRICATION NOTICE" color="warning" variant="outlined" size="small" sx={{ marginRight: '5px' }} />
				<a href="https://developer.atlassian.com/changelog/#CHANGE-2046">Deprecation of JQL search and Evaluate expression endpoints</a>
			</Alert>
			<NButton variant="contained" color="secondary" sx={{ marginTop: '30px' }} onClick={handleDownloadClick}>
				Download
			</NButton>
		</Grid>
	);
};
